module.exports = require('./dist/card.min.js').default;
